import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { AuthenticationService } from '../../authentication.service';
import Swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  httpUrl;
  constructor(private http: HttpClient, private auth: AuthenticationService) {
    this.httpUrl = this.auth.httpUrl;
  }


  async validatePdfSize(event: any) {
    const file = event.target.files[0];
    console.log(event)
    console.log(file)
    if (!file) {
      // Swal.fire('Info', 'Select File','error')
      return false;
    }
    const documentNameValidation = /^[a-zA-Z0-9\s._-]+$/
    const validTypes = ['application/pdf', 'application/img', 'image/png', 'image/jpeg', 'image/jpg', 'image/gfif', 'image/svg'];
    if (!validTypes.includes(file.type)) {
      Swal.fire('Info', 'Invalid File Type, Please upload PDF or Image file', 'error')
      return false;
    }
    if (file.name.length > 100) {
      Swal.fire('Info', 'File name is too long. Please use a name shorter than 100 characters.', 'error');
      return false;
    }
    if (!documentNameValidation.test(file.name)) {
      Swal.fire('Info', 'File name contains invalid characters. Only alphanumeric characters, spaces, hyphens, and underscores are allowed.', 'error');
      return false;
    }

    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      Swal.fire(
        'File Too Large',
        `The selected file exceeds the maximum allowed size of 5 MB. Your file size is ${(file.size / (1024 * 1024)).toFixed(2)} MB.`,
        'error'
      );
      return false;
    }
    return true
  }







}
